/**
 * Base abstract class for all wizard plugin data models
 */
export class BasePluginData {
  /**
   * User-friendly display name for the plugin (e.g., "Cloud Provider", "Client Allocation")
   * This should be set by the wizard builder from the plugin configuration
   */
  name?: string;

  /**
   * Gets the name of the plugin step this data model represents
   *
   * This property automatically returns the class name of the derived class,
   * ensuring consistency between the class name and its plugin step name.
   *
   * @returns The name of the class as the plugin step name
   */
  get pluginStepName(): string {
    return this.constructor.name;
  }

  /**
   * Gets the display name for the plugin, falling back to the internal step name
   * @returns The user-friendly name if available, otherwise the plugin step name
   */
  get displayName(): string {
    return this.name ?? this.pluginStepName;
  }
}
